export default __webpack_public_path__ + "static/media/twitter-round-color.b78938a8.svg";